import { PanelCategory, PanelConfig } from '@helios/panel-base'
import { ApprovalsPanelComponent } from './lib/approvals-panel.component'
import { ApprovalsKey } from './panel-key'

export const ApprovalsPanelConfig: PanelConfig = {
  key: ApprovalsKey,
  title: 'Approvals',
  description: 'View Approvals List',
  category: PanelCategory.DELIVERY,
  panelComponent: ApprovalsPanelComponent,
  accessPermission: 'accessApprovalsListPanel',
}
